<template>
  <v-container class="pa-0">
    <v-row class="font-weight-bold" no-gutters>
      <v-col cols="12">{{ $t('uso') }}</v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="ml-4">{{ escenario.use.name }}</v-col>
    </v-row>

    <v-row class="font-weight-bold" no-gutters>
      <v-col cols="12">{{ $t('frecuencia_mantenimiento') }}</v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="ml-4">{{ escenario.maintenanceFrequency.name }}</v-col>
    </v-row>

    <v-row class="font-weight-bold" no-gutters>
      <v-col cols="12">{{ $t('necesidad_higiene') }}</v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="ml-4">{{ escenario.needsHygiene.name }}</v-col>
    </v-row>

    <v-row class="font-weight-bold" no-gutters>
      <v-col cols="12">{{ $t('revestimiento_existente') }}</v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="ml-4">{{ escenario.existingCoating.name }}</v-col>
    </v-row>

  </v-container>
</template>

<script>
export default {
  name: "EscenarioVerticalR",
  props: {
    escenario: {type: Object, required: true}
  }
}
</script>

<style scoped>

</style>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "uso": "Uso",
    "frecuencia_mantenimiento": "Frecuencia de mantenimiento",
    "necesidad_higiene": "Necesidades especiales de higiene",
    "revestimiento_existente": "Revestimiento existente"
  }
}
</i18n>
<!--@formatter:on-->